import type { SaleRecordExpanded } from "../../types/sales";

const ExpandableSaleRow: React.FC<{ sale: SaleRecordExpanded }> = ({ sale }) => {
  return (
    <tr className="bg-blue-50">
      <td colSpan={7} className="p-4">
        <table className="w-full text-sm">
          <thead className="border-b bg-blue-200 text-primary rounded-xl">
            <tr>
              <th className="text-left py-2 px-4">Product</th>
              <th>Qty</th>
              <th>Total Cost</th>
              <th>Unit Price</th>
              <th>Total Price</th>
              <th>Profit</th>
            </tr>
          </thead>
          <tbody>
            {sale.products.map((p) => (
              <tr key={p.productId}>
                <td className="px-4 py-2">{p.name}</td>
                <td className="px-4 py-2">{p.quantity}</td>
                <td className="px-4 py-2">GHS {p.cost.toLocaleString()}</td>
                <td className="px-4 py-2">GHS {p.sellingPrice}</td>
                <td className="px-4 py-2">GHS {p.revenue}</td>
                <td className="text-green-700">
                  GHS {(p.revenue - p.cost).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </td>
    </tr>
  );
};

export default ExpandableSaleRow;
